import { combineReducers } from "@reduxjs/toolkit";

import { organizationListingReducer } from "./OrganizationListingSlice";

export const organizationsReducer = combineReducers({
  organizationListing: organizationListingReducer,
});
